import type { FC, HTMLProps } from 'react';
import clsx from 'clsx';

interface IProps extends HTMLProps<HTMLButtonElement> {
    layout: 'primary' | 'secondary'
}

const Button: FC<IProps> = ({ layout, children, ...props }) => {
    return <button {...props} className={clsx("tw-font-[500] tw-cursor-pointer tw-py-[13px] tw-w-full tw-rounded-lg tw-border-0 xxxl:tw-leading-[32px] tw-text-base xxxl:tw-text-[18.67px]", { 'tw-bg-[#007FAC] hover:tw-bg-[#007FAC]/90 tw-text-[#FFFFFF]': layout === 'primary', 'tw-bg-[#DCEDF3] hover:tw-bg-[#DCEDF3]/90 tw-text-[#007FAC]': layout === 'secondary' })}>
        {children}
    </button>
}

export default Button;